/*
  The old pdpPlace() lived here: it moved the gw-b2g1 / gw-trust section wrappers into the
  buy box with JS. That made the theme editor report "broken HTML" on main-product.liquid
  (a section nested inside another section), and a hero re-render destroyed the moved
  blocks. Both now render server-side from main-product.liquid via the
  gw-buybox-upsell / gw-buybox-trust snippets. Do not reintroduce it.
*/

(function(){
  function fn(u){ return (u||'').split('?')[0].split('/').pop(); }
  function pdpGallery(){
    if(!document.body.classList.contains('template-product')) return;
    var thumbs=[].slice.call(document.querySelectorAll('[data-product-thumb]'));
    var hero=document.querySelector('.product-main__hero');
    if(thumbs.length<2 || !hero) return;
    var form=document.querySelector('[data-product-form]'); if(!form) return;
    var colorGroup=null;
    [].slice.call(form.querySelectorAll('.product-main__option')).forEach(function(w){ var l=w.querySelector('label'); if(l && /colou?r|kleur/i.test(l.textContent||'')) colorGroup=w; });
    if(!colorGroup) return;
    var thumbFiles=thumbs.map(function(t){ return fn(t.getAttribute('data-img')); });
    fetch(location.pathname.split('?')[0]+'.js').then(function(r){return r.json();}).then(function(p){
      var colorFeat={};
      (p.variants||[]).forEach(function(v){ var c=(v.options&&v.options[0])||''; if(colorFeat[c]===undefined){ colorFeat[c]= (v.featured_image&&v.featured_image.src)? fn(v.featured_image.src): null; } });
      var starts=[];
      Object.keys(colorFeat).forEach(function(c){ var f=colorFeat[c]; var idx= f? thumbFiles.indexOf(f): -1; starts.push({c:c, idx:idx}); });
      var known=starts.filter(function(s){return s.idx>=0;}).sort(function(a,b){return a.idx-b.idx;});
      if(known.length<2) return;
      var ranges={};
      known.forEach(function(s,i){ var end=(i+1<known.length)? known[i+1].idx : thumbs.length; ranges[s.c]=[s.idx,end]; });

      /* Deliberately NOT stretching the first colour's range back to index 0.
         The gallery now opens with product-wide shots (worn in forest/city/home, the shoe
         rolled up in a hand, top-down toe box, sole profile) that sit BEFORE any colour's
         featured image. Stretching made the first colour in the list swallow them and, worse,
         set its hero to a photo of a completely different colourway - selecting Mauve showed
         a white shoe. Those leading shots are picked up as universal below, so every colour
         still shows them; only the hero now stays true to the selected colour. */

      /* Universal shots: any thumb that is not the featured image of some colour belongs to
         the product as a whole (detail shots, lifestyle). Those used to fall inside whichever
         colour block they happened to sit next to, so they vanished for the other 18 colours.
         Keep them visible on every colour. */
      var isFeat={};
      known.forEach(function(s){ isFeat[s.idx]=1; });
      var universal=[];
      thumbs.forEach(function(t,i){ if(!isFeat[i]) universal.push(i); });

      function apply(color){
        var rg=ranges[color];
        if(!rg){ thumbs.forEach(function(t){ t.style.display=''; }); return; }
        thumbs.forEach(function(t,i){
          var inRange=(i>=rg[0]&&i<rg[1]);
          var isUniversal=(universal.indexOf(i)>-1);
          t.style.display=(inRange||isUniversal)?'':'none';
        });
        hero.src=thumbs[rg[0]].getAttribute('data-img');
      }
      function pillVal(b){ return (b.getAttribute('aria-label')||b.textContent||'').trim(); }
      var pills=[].slice.call(colorGroup.querySelectorAll('.gw-sw,.gw-pill'));
      if(pills.length){
        pills.forEach(function(b){ b.addEventListener('click', function(){ apply(pillVal(b)); }); });
        var on=colorGroup.querySelector('.gw-sw.is-on,.gw-pill.is-on');
        apply(on?pillVal(on):known[0].c);
      } else {
        var sel=colorGroup.querySelector('select');
        if(sel){ sel.addEventListener('change', function(){ apply(sel.value); }); apply(sel.value); }
        else apply(known[0].c);
      }
    }).catch(function(){});
  }
  if(document.readyState!=='loading') setTimeout(pdpGallery,60); else document.addEventListener('DOMContentLoaded', function(){ setTimeout(pdpGallery,60); });
})();

(function(){
  // main-product renders the under-ATC quote avatar as initials; swap in the real headshot.
  function pdpAvatar(){
    if(!document.body.classList.contains('template-product')) return;
    var qav=document.querySelector('.product-main__quote-avatar');
    if(!qav) return;
    qav.textContent='';
    qav.style.backgroundImage='url(https://cdn.shopify.com/s/files/1/0971/3087/3160/files/hf_20260717_083335_93e66691-fe50-480d-99c8-ddd2f76a3021.png?v=1784277416&width=120)';
    qav.style.backgroundSize='cover';
    qav.style.backgroundPosition='center 22%';
  }
  if(document.readyState!=='loading') pdpAvatar(); else document.addEventListener('DOMContentLoaded', pdpAvatar);
})();
